<div class="d-flex align-items-center justify-content-center main-container">
    <div class="d-flex flex-column" style="width: 22%;">
        <img style="width : 100%" src="assets/images/family-treasures.png">
        <span *ngIf="!isUnsupportedSettings" id="cycle" class="loading">{{ text | translate}}</span>
    </div>
    <!-- <div style="position: absolute; bottom: 4%; left: 0; width: 100%;" class = "d-flex align-items-center justify-content-center">
        <span id = "cycle" class = "loading" style="font-size: 20px; color: #5f605e;">Loading</span>
    </div> -->
</div>